import { StatSegmentRegistry } from '@/types/stats/StatSegmentRegistry.ts';

/** Wiek na dzień startu wyjazdu. Kubełki są stałe, nie z cennika. */
export enum AgeBucketKey {
  UNDER_7 = 'UNDER_7',
  AGE_7_9 = 'AGE_7_9',
  AGE_10_12 = 'AGE_10_12',
  AGE_13_15 = 'AGE_13_15',
  AGE_16_17 = 'AGE_16_17',
  ADULT = 'ADULT',
}

/**
 * Wszystkie tony neutralne: wiek nie jest stanem, a `BarList` i tak maluje
 * paski jedną barwą listy.
 */
export const AGE_BUCKET_REGISTRY: StatSegmentRegistry = {
  [AgeBucketKey.UNDER_7]: { label: 'do 6 lat', tone: 'neutral' },
  [AgeBucketKey.AGE_7_9]: { label: '7–9 lat', tone: 'neutral' },
  [AgeBucketKey.AGE_10_12]: { label: '10–12 lat', tone: 'neutral' },
  [AgeBucketKey.AGE_13_15]: { label: '13–15 lat', tone: 'neutral' },
  [AgeBucketKey.AGE_16_17]: { label: '16–17 lat', tone: 'neutral' },
  [AgeBucketKey.ADULT]: { label: 'dorośli', tone: 'neutral' },
};
